import { render, staticRenderFns } from "./MenuFormDialogDuplicate.vue?vue&type=template&id=71480645"
import script from "./MenuFormDialogDuplicate.vue?vue&type=script&lang=ts"
export * from "./MenuFormDialogDuplicate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports